<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading">
    <div class="flex gap-0 cursor-pointer">
        <p class="font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-blacks">Required Items</p>
    </div>

    <!-- Scrollable filter section only -->
    <div class="w-full px-10 py-7 min-h-screen bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg overflow-x-auto">

        <div class="flex flex-row items-center justify-between min-w-max max-w-[80vw] mx-auto">
            <div class="flex flex-col justify-between flex-shrink-0">
                <p class="text-lg font-semibold dark:text-white">Required Items on {{selectedDate | date:'yyyy/MM/dd' }}
                </p>
            </div>
            <div class="flex flex-row items-center gap-4 flex-shrink-0">

                <div class="flex gap-4 flex-shrink-0">
                    <!-- Province Dropdown -->
                    <div class="w-48 ">
                        <app-custom-datepicker [selectedDate]="selectedDate" (dateChange)="onDateChange($event)"
                            title="Schedule Date"
                            triggerClass="w-full h-11 border-[1.8px] border-[#828282] rounded-xl flex items-center px-3 py-2 cursor-pointer dark:bg-[#292929]"></app-custom-datepicker>
                    </div>

                    <div *ngIf="logingRole === 'Distribution Centre Head'"
                        class="relative w-52  custom-center-dropdown-container">
                        <app-searchable-dropdown [items]="centerDropdownItems" placeholder="Centre"
                            searchPlaceholder="Search centre..." [(ngModel)]="selectCenters"
                            (selectionChange)="onCenterSelectionChange($event)" [clearable]="true" [showSelected]="true"
                            [disabled]="false" class="w-full"></app-searchable-dropdown>
                    </div>
                </div>

                <div
                    class="flex items-center mr-5 rounded-full px-4 py-2 w-96 bg-[#F1F1F1] dark:bg-[#292929] flex-shrink-0">
                    <input type="text" placeholder="Search by Product Name.." [(ngModel)]="searchText"
                        class="bg-transparent outline-none w-full text-textLight dark:text-textDark"
                        (keydown.enter)="onSearch()" (keydown.esc)="offSearch()" />
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <p class="font-semibold md:text-lg lg:text-lg mb-1 dark:text-white whitespace-nowrap">All
            ({{ itemsArr.length < 10 ? '0' + itemsArr.length : itemsArr.length || '00' }})</p>

                <div *ngIf="hasData" class="flex flex-row mt-3 mb-0">
                    <button
                        class="bg-[#415CFF] text-white shadow-md font-medium rounded-lg py-2 px-5 mr-5 text-lg flex items-center"
                        (click)="downloadTemplate1()">
                        <i class="fa-solid fa-download px-2" *ngIf="!isDownloading"></i>
                        <i class="fa-solid fa-spinner fa-spin px-2" *ngIf="isDownloading"></i>
                        {{ isDownloading ? " Downloading..." : " Download" }}
                    </button>
                </div>

                <div *ngIf="hasData"
                    class=" min-w-max mt-5 mr-5 border-gray-100 border-[2px] rounded-lg dark:border-[#202021] overflow-hidden">
                    <table class="w-full min-w-max divide-y-2">
                        <thead
                            class="text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
                            <tr>
                                <th class="px-6 py-3 text-center font-normal ">No</th>
                                <th class="px-6 py-3 text-left font-normal ">Product Name</th>
                                <th class="px-6 py-3 text-left font-normal ">Qty (kg)</th>
                                <th class="px-6 py-3 text-center font-normal ">Delivery Date</th>
                                <th *ngIf="logingRole === 'Distribution Centre Head'"
                                    class="px-6 py-3 text-center font-normal">Centre Code</th>
                                <th *ngIf="logingRole === 'Distribution Centre Head'"
                                    class="px-6 py-3 text-left font-normal">Centre Name</th>
                            </tr>
                        </thead>
                        <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                            <tr class=" dark:text-gray-300 " *ngFor="let item of itemsArr let i = index">
                                <td class="px-6 py-3 font-medium text-center">
                                    {{ (i + 1) < 10 ? '0' + (i + 1) : (i + 1) }} </td>
                                <td class="px-6 py-3 font-medium text-left">{{ item.productName }}</td>
                                <td class="px-6 py-3 font-medium text-left">
                                    {{ item.qty | number:'1.3-3' }}
                                </td>
                                <td class="px-6 py-3 font-medium text-center">
                                    {{ item.sheduleDate | date:'d MMM, y' }}
                                </td>
                                <td *ngIf="logingRole === 'Distribution Centre Head'"
                                    class="px-6 py-3 font-medium text-center">{{ item.regCode }}</td>
                                <td *ngIf="logingRole === 'Distribution Centre Head'"
                                    class="px-6 py-3 font-medium text-left">{{ item.centerName }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div *ngIf="!hasData"
                    class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] dark:text-textDark mt-6">
                    <p class="text-[#494949] my-6 dark:text-textDark">--No Data Availabale--</p>
                    <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20 dark:text-textDark" />
                </div>
    </div>
</div>